// @ts-strict-ignore
import Alert from 'antd/lib/alert';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers/reducers';
import { selectOrgUser, selectReleasePilotRotation } from '../selectors/selectors';
import { displayReleasePilotName } from '../helpers/displayHelpers';

interface PendingPilotSwapAlertProps {
    orgId: string;
    appId: string;
}

const PendingPilotSwapAlert: React.FC<PendingPilotSwapAlertProps> = (props) => {
    const releasePilotRotation = useSelector((state: RootState) => selectReleasePilotRotation(state, props.appId));
    const pendingSwapRow = (releasePilotRotation?.items ?? []).find((item) => item.isPilotOverridePending);
    const swappedToOrgUser = useSelector((state: RootState) =>
        pendingSwapRow?.overridePilotId ? selectOrgUser(state, props.orgId, pendingSwapRow.overridePilotId) : null,
    );

    if (!pendingSwapRow) {
        return <></>;
    }

    return (
        <Alert
            style={{ marginTop: 10, marginBottom: 16 }}
            type="warning"
            description={
                <>
                    This cancels the one-off pilot swap queued for <b>{pendingSwapRow.releaseVersion}</b> (swapped to{' '}
                    <b>{displayReleasePilotName(swappedToOrgUser, pendingSwapRow.overridePilotId, true)}</b>). Only that
                    swap is cancelled — the rotation order is unchanged.
                </>
            }
        />
    );
};

export default PendingPilotSwapAlert;
